var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { collectUniqueErrorMessages } from "./formErrorUtils";
/**
 * Content of the warning shown when an authority (person) form is submitted
 * with missing or invalid required fields: a "record not saved" heading
 * followed by the unique field error messages, one per line (DB-495).
 */
export var buildPersonInvalidSubmitContent = function (formatMessage, errors) {
    return __spreadArray([
        formatMessage({ id: "ui-br-agency.person.form.invalid" })
    ], collectUniqueErrorMessages(errors), true).map(function (message) { return React.createElement("div", { key: message }, message); });
};
